var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrdersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11V6C9 5.20435 9.31607 4.44129 9.87868 3.87868C10.4413 3.31607 11.2044 3 12 3C12.7956 3 13.5587 3.31607 14.1213 3.87868C14.6839 4.44129 15 5.20435 15 6V11M6.331 8H17.67C17.9584 7.99997 18.2433 8.06229 18.5054 8.1827C18.7674 8.30311 19.0003 8.47876 19.1881 8.6976C19.3758 8.91645 19.5141 9.17331 19.5933 9.45059C19.6725 9.72786 19.6908 10.019 19.647 10.304L18.392 18.456C18.2831 19.1644 17.9241 19.8105 17.38 20.2771C16.8359 20.7438 16.1428 21.0002 15.426 21H8.574C7.8574 21 7.16448 20.7434 6.62063 20.2768C6.07678 19.8102 5.71793 19.1643 5.609 18.456L4.354 10.304C4.31017 10.019 4.32849 9.72786 4.40771 9.45059C4.48693 9.17331 4.62516 8.91645 4.81295 8.6976C5.00073 8.47876 5.23362 8.30311 5.49565 8.1827C5.75767 8.06229 6.04264 7.99997 6.331 8Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/OrdersIcon.e8049a98b94444cd70ce2438e7418c60.svg";
export { ForwardRef as ReactComponent };